import init_brand_select from "./search/brand-select";
import "./search/serp-order";
import "./search/add-subscription";

jQuery(() => {
    init_brand_select();
});
